import * as Yup from 'yup';
import FileUploadInput from 'src/components/FileUploadInput';
import { SxProps } from 'src/theme/types/sxProps';
import ReadonlyField from 'src/components/ReadonlyField';
import { TextField } from '@mui/material';
import Select from 'src/components/Select';
import compact from 'lodash/compact';
import {
  SolutionMappingConfigType,
  SolutionMappingFilterField,
  SolutionMappingListItemField,
  SolutionMappingSourceType,
} from '../../types';
import {
  SOLUTIONMAPPINGCONFIGDESTINATION,
  SOLUTIONMAPPINGCONFIGSOURCE,
} from '../constant';
import SolutionMappingConfigEditFormRow from './SolutionMappingConfigEditFormRow';

const inputStyle: SxProps = { width: ({ spacing }) => spacing(40) };

export const getMappingConfigFilterFields = (
  destinationOptions?: any,
  loadingDestinationOptions?: boolean,
  adxColumnsData?: any,
  loadingAdxColumns?: boolean
) => {
  const sourceValidation = Yup.string()
    .required('Source is required')
    .test(
      'is-valid-source',
      'Select a valid source',
      (value) => {
        if (!value) return false;
        if (!adxColumnsData || adxColumnsData.length === 0) {
          return false;
        }
        const validValues = adxColumnsData.map((opt: any) => opt.value);
        return validValues.includes(value);
      }
    );

  const destinationValidation = Yup.string()
    .required('Destination is required')
    .test(
      'is-valid-destination',
      'Select a valid destination',
      (value) => {
        if (!value) return false;
        if (!destinationOptions || destinationOptions.length === 0) {
          return false;
        }
        const validValues = destinationOptions.map((opt: any) => opt.value);
        return validValues.includes(value);
      }
    );

  return [
    {
      name: SolutionMappingFilterField.sourceProperty,
      label: 'Source',
      placeholder: 'Select the value',
      Component: Select,
      options: adxColumnsData,
      loading: loadingAdxColumns,
      validation: sourceValidation,
      required: true,
      sx: { width: ({ spacing }) => spacing(40) },
    },
    {
      name: SolutionMappingFilterField.destinationProperty,
      label: 'Destination',
      placeholder: 'Select the value',
      Component: Select,
      options: destinationOptions,
      loading: loadingDestinationOptions,
      validation: destinationValidation,
      required: true,
      sx: { width: ({ spacing }) => spacing(40) },
    },
  ];
};

export const mappingConfigurationFormFields = (
  isEditMode: boolean,
  destinationType?: string,
  filePath?: string,
  usdOptions?: any,
  optionloading?: boolean,
  destinationOptions?: any,
  loadingDestinationOptions?: boolean,
  adxOptions?: any,
  loadingAdxTables?: boolean,
  sourceType?: string,
  adxTableName?: string,
  adxColumnsData?: any,
  loadingAdxColumns?: boolean
) =>
  compact([
    {
      name: SolutionMappingListItemField.sourceType,
      label: 'Source',
      Component: Select,
      placeholder: 'Select the option',
      required: true,
      validation: Yup.string().required('Source is required'),
      options: SOLUTIONMAPPINGCONFIGSOURCE,
      sx: inputStyle,
    },
    {
      name: SolutionMappingListItemField.destinationType,
      label: 'Destination',
      Component: Select,
      placeholder: 'Select the option',
      required: true,
      validation: Yup.string().required('Destination is required'),
      options: SOLUTIONMAPPINGCONFIGDESTINATION,
      sx: inputStyle,
    },
    sourceType === SolutionMappingSourceType.UniversalEdge && {
      name: SolutionMappingListItemField.tableName,
      label: ' ADX Table',
      Component: Select,
      placeholder: 'Select the option',
      required: true,
      validation: Yup.string().required('ADX Table is required'),
      options: adxOptions,
      loading: loadingAdxTables,
      sx: inputStyle,
    },
    destinationType === SolutionMappingConfigType.Omniverse && {
      name: SolutionMappingListItemField.path,
      label: 'USD File',
      Component: Select,
      placeholder: 'Select the option',
      required: true,
      disabled: isEditMode,
      validation: Yup.string().required('USD File is required'),
      options: usdOptions,
      loading: optionloading,
      sx: inputStyle,
    },
    {
      name: SolutionMappingListItemField.mappings,
      appendLabel: 'Mapping',
      childFields: getMappingConfigFilterFields(
        destinationOptions,
        loadingDestinationOptions,
        adxColumnsData,
        loadingAdxColumns
      ),
      RowComponent: SolutionMappingConfigEditFormRow,
      maxRows: 50,
    },
  ]);
